import styled from "styled-components";
import { LIGHT_BLUE, LIGHT_GRAY } from "../../config";

export const Container = styled.div<{ color?: string }>`
  position: relative;
  display: flex;
  height: 20px;
  align-items: center;

  label {
    display: flex;
    align-items: center;
    font-weight: normal;
    font-size: 14px;
    cursor: pointer;

    input {
      display: none;

      &:checked {
        & ~ .check {
          border: 2px solid ${({ color }) => color ?? LIGHT_BLUE};

          &:before {
            background: ${({ color }) => color ?? LIGHT_BLUE};
            transform: scale(1);
          }
        }
      }

      &:disabled {
        & ~ div {
          cursor: not-allowed;
        }

        & ~ .check {
          border: 2px solid ${LIGHT_GRAY};

          &:before {
            background: ${LIGHT_GRAY};
          }
        }
      }
    }

    .check {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-right: 4px;
      border: 2px solid ${LIGHT_GRAY};
      border-radius: 100%;
      height: 14px;
      width: 14px;
      transition: 0.2s ease;

      &:before {
        display: block;
        content: "";
        border-radius: 100%;
        width: calc(100% - 6px);
        height: calc(100% - 6px);
        transform-origin: center;
        transform: scale(0);
        transition: 0.2s ease;
      }
    }
  }
`;
